var numeral = require('numeral');
var NumeralFormatValueConverter = /** @class */ (function () {
    function NumeralFormatValueConverter() {
    }
    NumeralFormatValueConverter.prototype.toView = function (value, currencySymbol) {
        numeral.locale('en');
        var convertedNumeral = numeral(value).format('(' + currencySymbol + '0a)');
        return convertedNumeral;
    };
    return NumeralFormatValueConverter;
}());
export { NumeralFormatValueConverter };
var NumeralFormatFullAbbreviationValueConverter = /** @class */ (function () {
    function NumeralFormatFullAbbreviationValueConverter() {
    }
    NumeralFormatFullAbbreviationValueConverter.prototype.toView = function (value, currencySymbol) {
        numeral.locale('custom');
        var convertedNumeral = numeral(value).format('(' + currencySymbol + '0a)');
        return convertedNumeral;
    };
    return NumeralFormatFullAbbreviationValueConverter;
}());
export { NumeralFormatFullAbbreviationValueConverter };
